"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var deserialize = function deserialize(state, payload) {
  return state.merge(payload);
};

exports.deserialize = deserialize;
var serialize = function serialize(storage) {
  return _extends({}, storage, {
    put: function put(key, state, callback) {
      return storage.put(key, state.toJS(), callback);
    }
  });
};
exports.serialize = serialize;